import BlacklistModel from './blacklist.model.js';
import BoostModel from './boost.model.js';
import BuryModel from './bury.model.js';
import IncludeModel from './include.model.js';
import PinModel from './pin.model.js';
const model = {
    name: 'Rule',
    properties: {
        behaviors: {},
        blacklist: { type: 'model', model: BlacklistModel },
        boost: { type: 'array', model: BoostModel },
        bury: { type: 'model', model: BuryModel },
        include: { type: 'array', model: IncludeModel },
        pin: { type: 'array', model: PinModel },
    },
};
export default model;
